import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppService} from 'app/services/app.service';
import {SakuraModelService} from 'app/core/sakuraModel.service';
import {ApiResponse} from 'app/entities/apiResponse.entity';
import {Permissions} from 'app/entities/permissions.entity';
import {plainToInstance} from 'class-transformer';
import {Worker} from '../entities/worker.entity';
import {ChatService} from '../services/chat.service';
import {CaseMetadata} from "../../../chat-sdk/src/entities/caseMetadata";

@Injectable({
  providedIn: 'root'
})
export class UserModelService extends SakuraModelService {

  public token: string;
  public user: Worker = null;
  public worker: Worker = null;
  public permissions: Permissions = null;

  constructor(
    http: HttpClient,
    appService: AppService,
    private chatService: ChatService
  ) {
    super(http, appService);
  }

  makeLogin(callback: (status: boolean) => void) {

    if (this.token) {

      this.getStartData((answer) => {

        if (answer.status && answer.result) {

          this.user = plainToInstance(Worker, answer.result.user);

          this.worker = plainToInstance(Worker, answer.result.worker);

          this.permissions = new Permissions(answer.result.permissions);

          this.appService.setGAUserId(this.user.id);

          this.appService.showToolbar();
          this.chatService.initChat(this.user, this.worker, this.token);
          callback(true);

        } else {
          callback(false);
        }

      });

    } else {

      this.setToken(null);
      callback(false);
      this.appService.hideToolbar();

    }

  }

  setToken(token: string | null) {
    this.token = token;
    this.appService.setLocalStorage('token', this.token);
  }

  isLogin(): boolean {
    return !!(this.token && this.permissions);
  }

  checkPhone(phone: string, callback: (answer: ApiResponse) => void) {
    this.get({phone}, 'login-phone/check-phone', (answer: ApiResponse) => {
      callback(answer);
    });
  }

  sendCode(phone: string, callback: (answer: ApiResponse) => void) {
    this.get({phone}, 'login-phone/send-code', (answer: ApiResponse) => {
      callback(answer);
    });
  }

  checkCode(phone: string, code: string, callback: (answer: ApiResponse) => void) {
    this.get({phone, code}, 'login-phone/check-code', (answer: ApiResponse) => {
      callback(answer);
    });
  }

  getPermissions(callback: (answer: ApiResponse) => void) {
    this.get({}, 'pwa/permissions', (answer: ApiResponse) => {
      callback(answer);
    });
  }

  getChatPermissions(caseMetadata: CaseMetadata, callback: (answer: ApiResponse) => void) {
    console.log('chatPERMISSION', caseMetadata);
    this.post({caseMetadata}, {},'chat-pwa/permissions', (answer: ApiResponse) => {
      callback(answer);
    });
  }

  getStartData(callback: (answer: ApiResponse) => void) {
    this.get({}, 'pwa/start', (answer: ApiResponse) => {
      callback(answer);
    });
  }

  logout() {
    this.appService.hideToolbar();
    this.setToken(null);
    this.chatService.disconnectChat();
  }
}
